import React, { useState } from 'react';
import MathBackground from './components/MathBackground';
import { QRCodeSVG } from 'qrcode.react'; // Правильный импорт
import { FaKaggle, FaTelegram } from 'react-icons/fa'
import { FaGithub } from 'react-icons/fa';       // GitHub
import './App.css'; // Правильный импорт

function App() {
  const [modalOpen, setModalOpen] = useState(false);

  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  // Ссылки на GitHub и Telegram (замените на свои)
  const githubUrl = 'https://github.com/kayumovlev';
  const telegramUrl = 'https://t.me/rndlabs';
  const kaggleUrl = 'https://www.kaggle.com/levkayumov';

  // Общий стиль для кнопок
  const buttonStyle = {
    fontSize: '1rem',
    padding: '0.5rem 1rem',
    cursor: 'pointer',
    borderRadius: '5px',
    border: '1px solid #ccc',
    backgroundColor: 'transparent',
    color: '#555',
    transition: 'color 0.3s ease, border-color 0.3s ease',
    outline: 'none',
    margin: '0 0.5rem',
  };
  // Стиль для контейнера QR-кода
  const qrContainerStyle = {
    position: 'absolute',
    top: '20px',
    right: '20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
    zIndex: 2,
  };

  // Стиль для QR-кода
  const qrCodeStyle = {
    // RGBA
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    padding: '20px',
    borderRadius: '20px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    transition: 'transform 0.3s ease',
  };

  // Стиль для подписи
  const labelStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    fontSize: '0.9rem',
    color: 'black',
    fontWeight: '500',
    backgroundColor: 'rgba(255,255,255,0.9)',
    padding: '4px 8px',
    borderRadius: '6px',
  };

  // Хендлеры для наведения (чтобы не дублировать код)
  const handleMouseEnter = e => {
    e.currentTarget.style.color = '#000';
    e.currentTarget.style.borderColor = '#000';
  };
  const handleMouseLeave = e => {
    e.currentTarget.style.color = '#555';
    e.currentTarget.style.borderColor = '#ccc';
  };

  return (
    <div style={{ position: 'relative', minHeight: '90vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <MathBackground />
      {/* QR-код добавлен здесь */}
      <div style={qrContainerStyle}>
        <div
          style={qrCodeStyle}
        >
          <QRCodeSVG 
            value={telegramUrl}
            size={80}
          />
        </div>
        
        {/* Подпись с иконкой Telegram */}
        <span style={labelStyle}>
          <FaTelegram />
          Telegram Channel
        </span>
      </div>


      {/* Контент */}
      <div
        style={{
          position: 'relative',
          zIndex: 1,
          padding: '2rem',
          backgroundColor: 'rgba(255, 255, 255, 0.7)', // полупрозрачный фон
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          textAlign: 'center',
          maxWidth: '400px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '1rem',
        }}
      >
        <h1 style={{ fontSize: '4rem', margin: '0 0 1rem 0' }}>Levandox</h1>
        <div>
          <button
            onClick={openModal}
            style={buttonStyle}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            About
          </button>
        </div>
      </div>

      {/* Модальное окно с блюром и затемнением */}
      {modalOpen && (
        <div
          onClick={closeModal}
          style={{
            position: 'fixed',
            top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            backdropFilter: 'blur(5px)',
            WebkitBackdropFilter: 'blur(5px)', // для Safari
            zIndex: 10,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '1rem',
          }}
        >
          <div
            onClick={e => e.stopPropagation()}
            style={{
              backgroundColor: 'rgba(255, 255, 255, 0.85)',
              padding: '2rem',
              borderRadius: '10px',
              maxWidth: '600px',
              maxHeight: '80%',
              overflowY: 'auto',
              boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
              textAlign: 'left',
              color: '#222',
              fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
              lineHeight: '1.5',
              fontSize: '1.3rem',
            }}
          >
            <h2 style={{ marginTop: 0, marginBottom: '1.5rem', fontWeight: '700', fontSize: '2.8rem', textAlign: 'center' }}>About Me</h2>
            <p style={{ marginBottom: '1rem' }}>
              My name is <strong>Lev Kayumov</strong> (aka <em>Levandox</em>), and I am 16 y. o.
            </p>
            <p style={{ marginBottom: '1rem' }}>
              I am a machine learning developer, olympiad competitor, and passionate mathematician. I enjoy reading and writing scientific articles.
            </p>
            <p style={{ marginBottom: '1rem' }}>
              Here are some of my achievements:
            </p>
            <ul style={{ 
              listStyle: 'disc inside', 
              marginBottom: '1.5rem',
              paddingLeft: '1rem',
              color: '#007bff',
              fontWeight: '600',
              fontSize: '1.2rem',
            }}>
              <li>🥈 Silver medalist of the AI Challenge</li>
              <li>Finalist of the T1 Olympiad</li>
              <li>Finalist of the DLS Olympiad</li>
              <li>Participant of the NEOAI International Olympiad</li>
            </ul>
            <p style={{ marginBottom: '0' }}>
              I am actively involved in projects related to machine learning and data analysis, constantly striving to deepen my knowledge and skills in these fields.
            </p>
            <p style={{ marginBottom: '1rem' }}>
              And for 8 years, I was engaged in football :)
            </p>
            <p style={{ fontStyle: 'italic', marginTop: '1rem', color: '#555', fontSize: '1rem', textAlign: 'center'}}>
              *These are some of my achievements, and I continue to pursue new challenges and growth.*
            </p>
            <div style={{
              display: 'flex',
              padding: '10px',
              justifyContent: 'space-around',
              gap: 'clamp(5px, 2vw, 10px)',
              flexWrap: 'nowrap',
              overflowX: 'hidden'
            }}>
              {[
                { icon: FaGithub, text: 'GitHub', url: githubUrl },
                { icon: FaTelegram, text: 'Telegram', url: telegramUrl },
                { icon: FaKaggle, text: 'Kaggle', url: kaggleUrl }
              ].map(({ icon: Icon, text, url }) => (
                <a
                  key={text}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-button"
                  style={{ 
                    ...buttonStyle,
                    padding: 'clamp(4px, 1vw, 8px)'
                  }}
                >
                  <span className="social-button-container">
                    <Icon className="social-icon" />
                    <span className="social-button-text">{text}</span>
                  </span>
                </a>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
